import { useState } from 'react';
import { isValidEmail } from '../utils/validation';

const EmailInput = ({ value, onChange, showOptionalLabel = false }) => {
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);

    if (inputValue && !isValidEmail(inputValue)) {
      setError('Please enter a valid email address');
    } else {
      setError('');
    }
  };

  const handleBlur = () => {
    if (!value) {
      setError('');
    }
  };

  return (
    <div className="form-block mobile-input-block">
      <label htmlFor="emailAddress" style={{ fontWeight: 'bold' }}>
        Email Address
        {showOptionalLabel && <span className="optional-label"> (optional)</span>}
      </label>
      <input
        id="emailAddress"
        type="email"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Enter your email address (e.g., example@email.com)"
        maxLength="254"
        className={error ? 'input-error' : ''}
      />
      {error && <p className="field-error-message">{error}</p>}
    </div>
  );
};

export default EmailInput;
